module.exports = __webpack_public_path__ + "static/media/kennedy_murray_rodriguez_muley_bonfe.c940bd5f.jpg";